import {
  ApplicationConfig,
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { AuthInterceptorService } from '@modules/auth/services/auth-interceptor.service';
import { provideLottieOptions } from 'ngx-lottie';
import { CurrencyService } from '@modules/flights/services/interceptors/currency.service';
import { delegatorAgencyInterceptor } from '@modules/flights/services/interceptors/delegatorAgency.interceptor';
import { ConsolidatorIdInterceptor } from '@modules/auth/services/interceptors/consolidatorId.interceptor';
import { OrganizationIdInterceptor } from '@modules/auth/services/interceptors/organizationId.interceptor';
import { RECAPTCHA_SETTINGS } from 'ng-recaptcha-2';
import { environment } from 'environments/environment';
import { DeviceIdInterceptor } from '@modules/auth/services/interceptors/deviceId.interceptor';
import { TabContextService } from '@modules/auth/services/tab-context.service';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  provideMomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';

export const MY_DATE_FORMATS = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (tabCtx: TabContextService) => () => {
        const raw = localStorage.getItem('user');
        let userId: string | undefined;
        try {
          userId = raw ? JSON.parse(raw)?._id : undefined;
        } catch {
          userId = undefined;
        }
        tabCtx.hydrateFromInheritTicket(userId);
      },
      deps: [TabContextService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CurrencyService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: delegatorAgencyInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConsolidatorIdInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OrganizationIdInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DeviceIdInterceptor,
      multi: true,
    },
    {
      provide: DatePipe,
    },
    provideMomentDateAdapter(),
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    provideHttpClient(withFetch()),
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: '$',
    },
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaV2Key,
      },
    },
  ],
};
